import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "top-tool"
};
const _hoisted_2 = {
  key: 1,
  class: "none-tool"
};
const _hoisted_3 = {
  key: 2,
  class: "bottom-tool"
};
const _hoisted_4 = {
  key: 3,
  class: "none-tool"
};
import { useGolobalCommonStateStore } from '@/stores/useGlobalCommonStateStore';
import { useMapStyleStore } from '@/stores/useMapStyleStore';

import { defineAsyncComponent, computed, onUnmounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    topToolList: {
      default: () => [{
        name: 'AddressSearch'
      }, {
        name: 'LngLatLocate'
      }]
    },
    bottomToolList: {
      default: () => [{
        name: 'Layer'
      }, {
        name: 'BanFlyZone'
      }, {
        name: 'Change23D'
      }]
    },
    placement: {
      default: 'left'
    },
    mapContainerId: {
      default: ''
    }
  },
  setup(__props) {
    const AddressSearch = defineAsyncComponent(() => import('./components/AddressSearch/index.vue'));
    const LngLatLocate = defineAsyncComponent(() => import('./components/LngLatLocate/index.vue'));
    const BanFlyZone = defineAsyncComponent(() => import('./components/BanFlyZone/index.vue'));
    const Change23D = defineAsyncComponent(() => import('./components/MapModeToggle/index.vue'));
    const Layer = defineAsyncComponent(() => import('./components/Layer/index.vue'));
    const golobalCommonState = useGolobalCommonStateStore();
    const mapStyleStore = useMapStyleStore();
    const toolComponentMap = {
      AddressSearch,
      LngLatLocate,
      BanFlyZone,
      Change23D,
      Layer
    };
    const props = __props;
    const getToolComponent = name => {
      return toolComponentMap[name];
    };
    const toolBarOffset = computed(() => ['Layer', 'SkyRoad'].includes(golobalCommonState.currentUsedMapTool));
    onUnmounted(() => {
      golobalCommonState.setCurrentUsedMapTool('');
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["golobalCommonState", {
          'golobalCommonState-offset': _unref(toolBarOffset)
        }]),
        style: _normalizeStyle(_unref(mapStyleStore).toolBarStyle)
      }, [props.topToolList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.topToolList, item => {
        return _openBlock(), _createBlock(_resolveDynamicComponent(getToolComponent(item.name)), _mergeProps({
          key: item.name + 'top',
          placement: props.placement,
          "map-container-id": props.mapContainerId
        }, {
          ref_for: true
        }, _ctx.$attrs, {
          class: "top-tool-item"
        }), null, 16, ["placement", "map-container-id"]);
      }), 128)), _renderSlot(_ctx.$slots, "topToolAdd")])) : (_openBlock(), _createElementBlock("div", _hoisted_2)), props.bottomToolList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bottomToolList, item => {
        return _openBlock(), _createBlock(_resolveDynamicComponent(getToolComponent(item.name)), _mergeProps({
          key: item.name + 'bottom'
        }, {
          ref_for: true
        }, _ctx.$attrs, {
          placement: props.placement,
          "map-container-id": props.mapContainerId,
          class: "bottom-tool-item"
        }), null, 16, ["placement", "map-container-id"]);
      }), 128)), _renderSlot(_ctx.$slots, "bottomToolAdd")])) : (_openBlock(), _createElementBlock("div", _hoisted_4))], 6);
    };
  }
});